/*
 * --------------------------------------
 * Copyright (c) 2020 BetterCapital.US
 * --------------------------------------
 */

import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { Formik, Field } from "formik";
import * as Yup from "yup";
import { withRouter } from "react-router";

import customSelect from "../../../../shared/components/form/customSelect";

import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { connect } from "react-redux";
import { hideAddAssetsModal } from "../../../../actions/asset/addAssetsModalAction";

class AssetImport extends PureComponent {
  static propTypes = {
    data: PropTypes.object.isRequired,
    modalOpen: PropTypes.bool,
  };

  constructor(props) {
    super(props);
    this.state = {
      importFailed: false,
      loading: false,
    };
  }

  handleSubmit = (values, { props = this.props }) => {
    const { location } = props;
    const locationName = location.pathname;
    const routes = locationName.split("/");
    values.user_role = this.getRoleForAssetType(values.assetType);
    values.areaSquareFeet |= 0;
    values.lotSizeSquareFeet |= 0;
    props.addAssetEvent(values, routes[2]);
    this.setState({ loading: true });
    this.props.hideModal();
  };

  closeModal = () => {
    this.props.toggleModal();
    this.props.toggleMainModal();
  };

  getRoleForAssetType = (type) => {
    switch (type) {
      case "note":
      case "syndication":
      case "fund":
        return "I";
      case "rental":
      case "flip":
      case "for_sale":
      default:
        return "O";
    }
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    const { asset } = nextProps;
    if (
      prevState.loading &&
      asset.isSavingAssetSuccess === true &&
      asset.slug
    ) {
      return {
        loading: false,
      };
    } else if (asset.isSavingAssetSuccess === false) {
      return {
        loading: false,
        importFailed: true,
      };
    }
  }

  render() {
    const { data } = this.props;
    let initialValues = data;
    initialValues.user_role = "O";
    initialValues.management_platform = "";
    initialValues.assetType = "";

    const validationSchema = Yup.object({
      user_role: Yup.string("").required("Asset Role is required"),
      assetType: Yup.string("").required("Asset Type is required"),
      management_platform: Yup.string("").required(
        "Management Platform is required"
      ),
    });

    return (
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={this.handleSubmit}
        render={(props) => {
          const { handleSubmit } = props;
          const { modalOpen } = this.props;
          return (
            <Modal
              isOpen={modalOpen}
              className={"modal-dialog modal-dialog-centered"}
              contentClassName={"newexpensemodal"}
            >
              <ModalHeader toggle={this.closeModal}>
                <h5 className="modal-title">{"Import Asset"}</h5>
              </ModalHeader>
              <form onSubmit={handleSubmit}>
                <ModalBody>
                  <div className="form-group row">
                    <label htmlFor="type" className="col-sm-2 col-form-label">
                      Type:
                    </label>
                    <div className="col-sm-10 inputblock">
                      <Field
                        name="assetType"
                        component={customSelect}
                        placeholder="Select Asset Type"
                        options={[
                          { value: "primary", label: "Primary Residence" },
                          { value: "rental", label: "Rental" },
                          { value: "note", label: "Note/Trust Deed" },
                          { value: "syndication", label: "Syndication" },
                          { value: "flip", label: "Fix & Flip" },
                          { value: "fund", label: "Fund" },
                          { value: "for_sale", label: "For Sale" },
                        ]}
                      />
                    </div>
                  </div>
                  <div className="form-group row">
                    <label
                      htmlFor="management_platform"
                      className="col-sm-2 col-form-label"
                    >
                      Platform:
                    </label>
                    <div className="col-sm-10 inputblock">
                      <Field
                        name="management_platform"
                        component={customSelect}
                        placeholder="Select Platform"
                        options={[
                          { value: "appfolio", label: "AppFolio" },
                          { value: "buildium", label: "Buildium" },
                          { value: "hemlane", label: "Hemlane" },
                          { value: "propertyware", label: "PropertyWare" },
                          { value: "rentmanager", label: "RentManager" },
                          { value: "homeroom", label: "HomeRoom" },
                          { value: "quickbook", label: "QuickBooks" },
                          { value: "cozy", label: "Cozy.co" },
                          { value: "other", label: "Other" },
                          { value: "", label: "None" },
                        ]}
                      />
                    </div>
                  </div>
                </ModalBody>
                <ModalFooter>
                  <button
                    type="reset"
                    className="btn btn-secondary px-5 d-inline-block mx-2"
                    onClick={this.closeModal}
                    disabled={this.state.loading}
                  >
                    Cancel
                  </button>
                  <button
                    color="primary"
                    type="submit"
                    className="btn savebtns btn-primary px-5  d-inline-block mx-2"
                    disabled={this.state.loading}
                  >
                    Save{" "}
                  </button>
                </ModalFooter>
              </form>
            </Modal>
          );
        }}
      />
    );
  }
}

const mapStateToProps = (state) => ({
  asset: state.asset,
  addAssetEvent: state.assetsAddModal.saveMethod,
});

const mapDispatchToProps = (dispatch) => ({
  hideModal: () => hideAddAssetsModal(dispatch),
});
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(AssetImport)
);
